import { StyleSheet } from "react-native";
const style = StyleSheet.create({
    button: {
        minWidth: 56,
    },
    container: {
        flex: 1,
    },
});
export { style };
